import React from 'react';
import { motion } from 'framer-motion';

const CampaignCardSkeleton = ({ index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: index * 0.1 }}
      className="col-span-12 sm:col-span-6 xl:col-span-4 rounded-xl shadow-sm border overflow-hidden gch-bg-card"
      style={{
        borderColor: 'var(--admin-border)',
        fontFamily: '"Inter", sans-serif'
      }}
    >
      {/* Header */}
      <div className="p-6 pb-4">
        <div className="flex items-start justify-between mb-4">
          {/* Game Type Icon Skeleton */}
          <div className="flex items-center gap-3">
            <div 
              className="w-10 h-10 rounded-lg animate-pulse flex items-center justify-center bg-[var(--admin-accent-light)]"
            >
              <div className="w-5 h-5 bg-[var(--admin-accent-light)] rounded" />
            </div>
            <div>
              {/* Title Skeleton */}
              <div 
                className="h-5 w-32 rounded animate-pulse mb-2 bg-white/10"
              />
              {/* Game Type Skeleton */}
              <div 
                className="h-3 w-20 rounded animate-pulse bg-white/5"
              />
            </div>
          </div>
          
          {/* Status Badge Skeleton */}
          <div 
            className="px-3 py-1 rounded-full text-xs font-bold animate-pulse bg-white/5"
          >
            <div className="w-12 h-3 bg-white/10" />
          </div>
        </div>

        {/* Description Skeleton */}
        <div className="space-y-2 mb-4">
          <div 
            className="h-3 w-full rounded animate-pulse bg-white/5"
          />
          <div 
            className="h-3 w-3/4 rounded animate-pulse bg-white/5"
          />
        </div>

        {/* Stats Section Skeleton */}
        <div className="grid grid-cols-2 gap-4 mb-4">
          <div className="text-center">
            <div 
              className="h-6 w-12 mx-auto rounded animate-pulse mb-1 bg-white/10"
            />
            <div 
              className="h-3 w-16 mx-auto rounded animate-pulse bg-white/5"
            />
          </div>
          <div className="text-center">
            <div 
              className="h-6 w-12 mx-auto rounded animate-pulse mb-1 bg-white/10"
            />
            <div 
              className="h-3 w-16 mx-auto rounded animate-pulse bg-white/5"
            />
          </div>
        </div>

        {/* Date Skeleton */}
        <div 
          className="h-3 w-24 rounded animate-pulse bg-white/5"
        />
      </div>

      {/* Footer Button Skeleton */}
      <div 
        className="px-6 py-4 border-t border-[var(--admin-border)]"
      >
        <div 
          className="h-10 w-full rounded-lg animate-pulse bg-[var(--admin-accent-light)]"
        />
      </div>
    </motion.div>
  );
};

const CampaignsSkeleton = ({ count = 6 }) => {
  return (
    <div className="max-w-7xl mx-auto" style={{ fontFamily: '"Inter", sans-serif' }}>
      {/* Header Skeleton */}
      <div className="mb-8 flex justify-between items-center">
        <div>
          <div 
            className="h-10 w-48 rounded animate-pulse mb-3 bg-white/10"
          />
          <div 
            className="h-4 w-64 rounded animate-pulse bg-white/5"
          />
        </div>
        
        <div className="flex items-center gap-3">
          {/* Filter Button Skeleton */}
          <div 
            className="h-10 w-20 rounded animate-pulse bg-white/5"
          />
          {/* Create Button Skeleton */}
          <div 
            className="h-10 w-36 rounded animate-pulse bg-[var(--admin-accent-light)]"
          />
        </div>
      </div>

      {/* Campaign Cards Grid Skeleton */}
      <div className="grid grid-cols-12 gap-6">
        {Array.from({ length: count }, (_, index) => (
          <CampaignCardSkeleton key={index} index={index} />
        ))}
      </div>
    </div>
  );
};

export default CampaignsSkeleton; 